import type { PluginObject, VueConstructor } from 'vue';

export default function withInstall<T extends Record<string, unknown>>(component: T) {
  (component as T & PluginObject<T>).install = (Vue: VueConstructor) => {
    const { name } = component as T & { name: string };
    Vue.component(name, component);
  };

  return component as T & PluginObject<T>;
}
